import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type ReceiptIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ReceiptIcon(props: ReceiptIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('ReceiptIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel ?? translate('Receipt')}
      {...rest}
    >
      <path
        d="M17.7871 2.93842C18.733 2.93842 19.5 3.70537 19.5 4.65131V19.8749C19.4998 20.3183 19.1397 20.6777 18.6963 20.6777C18.5478 20.6776 18.4019 20.6364 18.2754 20.5585L15.0957 18.6015L12.5195 20.663C12.2369 20.8891 11.8376 20.8983 11.5449 20.6855L8.72949 18.6376L5.59766 21.5273C5.27172 21.8281 4.76376 21.8082 4.46289 21.4824C4.32595 21.334 4.25002 21.1393 4.25 20.9374V4.65131C4.25 3.70537 5.01696 2.93842 5.96289 2.93842H17.7871ZM5.96289 3.93842C5.56924 3.93842 5.25 4.25766 5.25 4.65131V20.4882L8.16992 17.7929C8.45137 17.5333 8.87678 17.5082 9.18652 17.7333L12.0117 19.788L14.5791 17.7343C14.8438 17.5226 15.2132 17.5001 15.502 17.6777L18.5 19.5224V4.65131C18.5 4.25766 18.1808 3.93842 17.7871 3.93842H5.96289ZM12.4912 11.1435C12.7672 11.1437 12.9912 11.3675 12.9912 11.6435C12.991 11.9193 12.767 12.1433 12.4912 12.1435H8.38867C8.11265 12.1435 7.88887 11.9195 7.88867 11.6435C7.88867 11.3674 8.11253 11.1435 8.38867 11.1435H12.4912ZM14.542 7.1767C14.818 7.17672 15.0418 7.40071 15.042 7.6767C15.042 7.95282 14.8181 8.17667 14.542 8.1767H8.38867C8.11253 8.1767 7.88867 7.95284 7.88867 7.6767C7.88884 7.40069 8.11263 7.1767 8.38867 7.1767H14.542Z"
        fill={props.fill || '#1B2C4F'}
      />
    </svg>
  )
}
